// const API_BASE_URL = "http://localhost:5000/";
const API_BASE_URL = "https://exam-api.sbmranchi.org/";

export const roleAccess = {
  Head: [
    "/dashboard",
    "/exam-master",
    "/grade-master",
    "/subject-master",
    "/criteria-master",
  ],
  Exam: [
    "/dashboard",
    "/marks-entry",
    "/criteria-entry",
    "/exam-wise-report",
    "/half-yearly-report",
    "/annual-report",
  ],
};

export default API_BASE_URL;
